<template>
<m-pageframe
    :title="title"
    :title_jump_to_organization_id="organization_id"
>
<v-container
   
    fluid
    style="padding: 30px"
>
<div
  v-if="profile != null"
>
<h2>Welcome to RedChirp!</h2>



<v-expansion-panels
  style="margin-top: 15px"
  v-model="open_panel"
>
    <v-expansion-panel
      v-for="(item, index) in optional_sections"
      :key="'opt_section_'+index"
    >
      <m-welcome-expansion-panel-header
        :label="item.title"
        :complete="item.is_complete"
      />
      <v-expansion-panel-content>
      <m-welcome-optional-section
        :section="item"
        v-on:reload-profile="update"
      />
      </v-expansion-panel-content>
    </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.sign_subscription_agreement_outside_of_redchirp"
  >
    <m-welcome-expansion-panel-header
      label="Accept the RedChirp software subscription agreement"
      :complete="profile.subscription_signature != null"
    />
    <v-expansion-panel-content>
       <m-welcome-sign-subscription-agreement
          :profile="profile"
          v-on:reload-profile="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>


  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.payment_outside_of_redchirp"
    
  >
    <m-welcome-expansion-panel-header
      label="Provide a payment method"
       :complete="profile.setup_tasks.setup_payment_method_complete"
    />
    <v-expansion-panel-content>
      
      <m-redchirp-payment-org-controlled-billing-settings
        :organization_id="profile.organization_account.organization_id"
      />

      <m-redchirp-payment-methods  
          :organization_id="profile.organization_account.organization_id"
          :show_help_when_no_payment_methods="false"
      />

    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin && false"
  >
    <m-welcome-expansion-panel-header
      label="Register with The Campaign Registry (TCR)"
    />
    <v-expansion-panel-content>
      This is the content that will go here!
    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.general_setup_outside_redchirp"
  >
    <m-welcome-expansion-panel-header
      label="General Information"
      :complete="profile.setup_tasks.general_setup_data_complete"
    />
    <v-expansion-panel-content>
      
      <m-welcome-general
        :profile="profile"
        v-on:reload="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>


  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.tcr_setup_outside_redchirp"
  >
    <m-welcome-expansion-panel-header
      label="Information for The Campaign Registry (TCR)"
      :complete="profile.setup_tasks.tcr_setup_data_complete"
    />
    <v-expansion-panel-content>
      
      <m-welcome-tcr
        :profile="profile"
        v-on:reload="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.website_setup_outside_redchirp"
  >
    <m-welcome-expansion-panel-header
      label="Webchat"
      :complete="profile.setup_tasks.website_setup_data_complete"
    />
    <v-expansion-panel-content>
      
      <m-welcome-website
        :profile="profile"
        v-on:reload="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin && !profile.setup_tasks.integrations_setup_outside_redchirp"
  >
    <m-welcome-expansion-panel-header
      label="Integrations"
      :complete="profile.setup_tasks.integrations_setup_data_complete"
    />
    <v-expansion-panel-content>
      
      <m-welcome-integrations
        :profile="profile"
        v-on:reload="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

  

  <v-expansion-panel
     v-if="$rc.$state.isAuthActorSystemAdmin() || (profile.numbering_plan.state != 'do-not-show' && is_org_admin)"
  >
    <m-welcome-expansion-panel-header
      label="Phone Number Plan"
      :complete="profile.numbering_plan.state == 'complete'"
    />

    <v-expansion-panel-content>
      <m-welcome-numbering-plan
        :profile="profile"
        v-on:update-profile="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
     v-if="is_org_admin"
  >
    <m-welcome-expansion-panel-header
      label="Setup your team members"
      :complete="profile.setup_tasks.setup_team_members_complete"
    />
    <v-expansion-panel-content>
      <m-welcome-setup-team
        :profile="profile"
        v-on:update-profile="updateProfile"
        v-on:reload-profile="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

  <v-expansion-panel
  >
    <m-welcome-expansion-panel-header
      label="Get ready for your RedChirp training"
      :complete="profile.setup_tasks.ready_for_training"
    />
    <v-expansion-panel-content>
      <m-welcome-get-ready-for-training
        :profile="profile"
        v-on:update-profile="updateProfile"
        v-on:reload="update"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>

</v-expansion-panels>

<div
  style="border: 1px solid rgba(0,0,0,0.2); padding: 15px; border-radius: 15px; margin-top: 30px;"
>
  <b>Articles and How To(s)</b>
  <br/><br/>

  Here are some helpful articles for you as you get started with RedChirp:

  <ul
    style="margin-top: 15px; margin-bottom: 15px;"
  >
    <li style="margin: 15px 0"><a href="https://redchirp.com/adding-the-redchirp-widget-to-your-website" target="_blank">How to add the RedChirp widget to your website (Instructions for your website administrator / designer)</a></li>

    
  </ul>

</div>

<m-welcome-sys-admins-only
  :profile="profile"
  style="margin-top: 30px"
  v-on:update-profile="updateProfile"
  v-on:reload-profile="update"
  ref="sys-admins-only"
/>


</div>

<m-eula-sign-dialog
    ref="m-eula-sign-dialog"
/>

<div
  style="position: fixed; right: 15px; bottom: 30px; z-index: 10000"
  v-if="is_mobile"
>
  <v-menu
        top
        offset-y
    >
        <template v-slot:activator="{ on }">
            
                <v-btn
                    v-on="on"
                    color="grey"
                    dark
                    fab
                    style="margin-right: 8px;"
                >
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
        </template>

          <v-list>
              <v-list-item
                v-on:click="onClickAddToHomeScreen()"
            >
                <v-list-item-title>Add RedChirp to your home screen...</v-list-item-title>
            </v-list-item>

        </v-list>
    </v-menu>
</div>



</v-container>
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            profile: null,
            open_panel: null,
        }
    },

    mounted () {
        this.open_panel = this.$rc.getOpenPanel(this.$route);
        this.update();
        this.checkEULA();
    },

    methods: {
      update() {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'GET: /api/v1/welcome/get-profile/:employee_id',
        
            'params' : {
                    'employee_id': this.$route.params.employee_id,
                },
        
            'on_success': (data) => {
                    this.updateProfile(data);

                    if ( data.organization_account.organization_state != 'pre-launch' && !this.$rc.$state.isAuthActorSystemAdmin() )
                    {
                      this.$router.push({
                        'name': 'home',
                        'params' : {
                        }
                      });
                    }

                    if ( !this.is_org_admin )
                    {
                      this.open_panel = 0;
                    }
                },
        
            'on_error': 'Unable to get welcome screen profile',
        });
      },

      updateProfile(profile)
      {
        this.profile = profile;
      },

      checkEULA()
      {
        this.$rc.checkEULA(
            (eula_check) => {

              if ( eula_check.signature_current == true ) 
                return;

              this.$refs['m-eula-sign-dialog'].showDialog(this.$rc.$state.employee_id);
            }
        );
      },

       onClickAddToHomeScreen()
        {
            this.$router.push({
                'name': 'ios-to-instructions'
            });
        },
      
    },

    computed: {
      is_org_admin() {
        if ( this.profile == null ) return false;
        if ( this.profile.employee_account.is_organization_admin != true ) return false;

        return true;
      },

      title() {
        if ( this.profile == null ) 
          return 'Welcome to RedChirp';

        return 'Welcome to RedChirp: '+this.profile.organization_account.label;
      },

      organization_id() {
        return this.$rc.getDeep(this.profile, 'organization_account/organization_id');
      },

      is_mobile()
      {
          return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
      },

      optional_sections()
      {
        if ( this.profile == null ) return [];
        if ( this.profile.employee_account.is_organization_admin != true ) return [];

        return this.profile.optional_sections;
      },
    },

}
</script>

<style lang="scss" scoped>
</style>